import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { company } from "../mock";

const CTAStrip = () => (
  <section className="py-16 bg-gradient-to-r from-[#00A859] to-[#00874A] relative overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 flex flex-wrap items-center justify-between gap-6">
      <div className="text-white max-w-2xl">
        <h3 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-2">
          Hai bisogno di una fornitura personalizzata?
        </h3>
        <p className="text-white/90 text-base">
          Contattaci per un preventivo gratuito e senza impegno. Il nostro team è
          a tua disposizione.
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <a
          href={`tel:${company.telRaw}`}
          className="inline-flex items-center gap-2 bg-white text-[#00874A] font-bold px-6 py-3.5 rounded-full text-sm uppercase tracking-wide hover:bg-gray-100 transition-colors"
        >
          <Phone className="w-4 h-4" /> {company.tel}
        </a>
        <Link
          to="/contatti"
          className="inline-flex items-center gap-2 border-2 border-white text-white font-bold px-6 py-3.5 rounded-full text-sm uppercase tracking-wide hover:bg-white hover:text-[#00874A] transition-colors"
        >
          Contattaci <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default CTAStrip;
